export default __webpack_public_path__ + "static/media/icon-dryer.45f070d7.svg";